export const CRUD_GET_ONE = 'EPIC/CRUD_GET_ONE';
export const CRUD_GET_ONE_FAILURE = 'EPIC/CRUD_GET_ONE_FAILURE';
export const CRUD_GET_ONE_SUCCESS = 'APIC/CRUD_GET_ONE_SUCCESS';
